export const COMPLIANCE_TEXT =
  "FLEETFLOW è un'infrastruttura tecnologica B2B SaaS di matchmaking riservata ad autisti professionisti titolari di licenza NCC / autorizzazioni di legge (Legge 21/1992). Non eroga servizi di trasporto diretto.";

export const ESCROW_SEAL = "Pagamento in Deposito Escrow Garantito • Sblocco automatico a corsa completata";

export const LEGAL_LINE =
  "Piattaforma B2B riservata esclusivamente a titolari di licenza NCC / autorizzazioni di legge (Legge 21/1992).";

export const LEGAL_SECTIONS = [
  {
    id: "tc",
    title: "Termini e Condizioni B2B (T&C)",
    body: [
      "Il servizio è riservato esclusivamente a operatori professionali titolari di autorizzazione NCC o titolo equivalente ai sensi della Legge 21/1992.",
      "FLEETFLOW mette in contatto operatori: il contratto di trasporto intercorre tra il cliente finale e l'operatore esecutore, che ne resta unico responsabile.",
      "Per ogni corsa conclusa è trattenuta una quota di gestione piattaforma del 10% sull'importo totale; il 90% spetta all'autista esecutore.",
    ],
  },
  {
    id: "privacy",
    title: "Privacy & Cookie Policy (GDPR EU)",
    body: [
      "I dati sono trattati ai sensi del Regolamento (UE) 2016/679 (GDPR) per la sola finalità di erogazione del servizio di matchmaking B2B e di verifica delle licenze.",
      "Titolare del trattamento: [Ragione sociale] — [Indirizzo] — [Email DPO]. L'utente può esercitare i diritti di accesso, rettifica, cancellazione e portabilità.",
      "I documenti di licenza caricati sono archiviati in modo privato e accessibili solo al titolare del profilo. Sono utilizzati solo cookie/archiviazione locale tecnici.",
    ],
  },
  {
    id: "escrow",
    title: "Garanzia Deposito Sicuro (Escrow Protection)",
    body: [
      "Alla prenotazione l'importo della corsa viene bloccato in deposito fiduciario e liberato automaticamente all'esecutore a corsa completata.",
      "In caso di mancata esecuzione l'importo viene restituito secondo le regole di rimborso indicate nei T&C.",
      "Fase di lancio: il collegamento con il provider di pagamento è in attivazione; al momento la prenotazione registra il blocco della corsa senza addebiti.",
    ],
  },
  {
    id: "license",
    title: "Verifica Licenza / Flotta",
    body: [
      "Tutti gli utenti registrati possono pubblicare e prenotare corse subito, senza attendere la verifica.",
      "Facoltativo: chi inserisce nel Profilo Numero Licenza NCC / Autorizzazione, Comune di Rilascio e la foto della licenza o del libretto ottiene il badge \"NCC Verificato 🛡️\".",
      "Il badge è visibile sul profilo e sulle corse pubblicate, così i colleghi riconoscono subito le flotte verificate.",
    ],
  },
];
